import {
  SocialPublish,
  SocialPublishPayload,
  FacebookPublish,
  FacebookPublishPayload,
  AssetItem,
  SocialChannel,
} from "@/database";
import BasePublishCard, {
  BasePublishCardProps,
  OnPublished,
} from "./BasePublishCard";
import { PlatformConfig } from "./platformConfig";

interface SocialPublishCardProps {
  initialdata: SocialPublish | FacebookPublish;
  assets: AssetItem[];
  disabled: boolean;
  handleCancelOrDelete: (
    initialdata: SocialPublish | FacebookPublish,
    type: string,
    cardType: string
  ) => void;
  callPublishMedia: (
    payload: SocialPublishPayload | FacebookPublishPayload,
    cb: (response: any) => void
  ) => void;
  updatePublishMedia: (
    payload: SocialPublishPayload | FacebookPublishPayload,
    cb: (response: any) => void
  ) => void;
  isPublishingMedia: boolean;
  mediaBaseUrl: string;
  expandedId: string | null;
  onToggleExpand: (id: string) => void;
  updateModal: any;
  isWizard: boolean;
  currentMediaDetails: any;
  isPreset?: boolean;
  handleAllSelectedPresets: (presets: any[]) => void;
  item: any;
  presetDetails: any;
  isPreview?: boolean;
  readOnlyMode?: boolean;
  metaPresetData?: any;
  socialChannelList?: SocialChannel[];
  inSheet?: boolean;
  onPublished?: OnPublished;
  onStageDraft?: (
    id: string,
    payload: any,
    opts?: { silent?: boolean }
  ) => void;
  autoStage?: boolean;
  onFieldEdited?: (
    id: string,
    field: "title" | "desc" | "tags" | "thumbnail"
  ) => void;
  onPersistEditedValues?: (id: string, patch: Record<string, any>) => void;
  onCardSaved?: (id: string) => void;
}

const SocialPublishCard = ({
  initialdata,
  assets,
  disabled,
  handleCancelOrDelete,
  callPublishMedia,
  updatePublishMedia,
  isPublishingMedia,
  mediaBaseUrl,
  expandedId,
  onToggleExpand,
  updateModal,
  isWizard,
  currentMediaDetails,
  isPreset = false,
  handleAllSelectedPresets,
  item,
  presetDetails,
  isPreview = false,
  readOnlyMode = false,
  metaPresetData,
  socialChannelList = [],
  inSheet,
  onPublished,
  onStageDraft,
  autoStage,
  onFieldEdited,
  onPersistEditedValues,
  onCardSaved,
}: SocialPublishCardProps) => {
  // Determine platform type
  const getPlatformType = () => {
    const jobType = initialdata?.job_type?.toLowerCase();
    const platformId = initialdata?.platform?.toLowerCase();
    const id = initialdata?.id?.toLowerCase();

    // Check for Facebook first
    if (jobType === "facebook") {
      return "facebook";
    }
    if (platformId === "facebook") {
      return "facebook";
    }

    // Check for other social platforms
    if (
      jobType &&
      ["linkedin", "twitter", "instagram", "dailymotion"].includes(jobType)
    ) {
      return jobType;
    }
    if (
      platformId &&
      ["linkedin", "twitter", "instagram", "dailymotion"].includes(platformId)
    ) {
      return platformId;
    }
    if (
      id &&
      ["linkedin", "twitter", "instagram", "dailymotion"].includes(id)
    ) {
      return id;
    }

    return "linkedin"; // default
  };

  const platformType = getPlatformType();

  // No platform-specific fields for social platforms (facebook, linkedin, twitter, instagram, dailymotion)
  const renderPlatformSpecificFields = () => {
    return null;
  };

  return (
    <BasePublishCard
      initialdata={initialdata}
      assets={assets}
      disabled={disabled}
      handleCancelOrDelete={handleCancelOrDelete}
      callPublishMedia={callPublishMedia}
      updatePublishMedia={updatePublishMedia}
      isPublishingMedia={isPublishingMedia}
      mediaBaseUrl={mediaBaseUrl}
      expandedId={expandedId}
      onToggleExpand={onToggleExpand}
      updateModal={updateModal}
      isWizard={isWizard}
      currentMediaDetails={currentMediaDetails}
      isPreset={isPreset}
      handleAllSelectedPresets={handleAllSelectedPresets}
      item={item}
      presetDetails={presetDetails}
      isPreview={isPreview}
      readOnlyMode={readOnlyMode}
      metaPresetData={metaPresetData}
      platform={platformType}
      inSheet={inSheet}
      onPublished={onPublished}
      onStageDraft={onStageDraft}
      autoStage={autoStage}
      onFieldEdited={onFieldEdited}
      onPersistEditedValues={onPersistEditedValues}
      onCardSaved={onCardSaved}
      renderPlatformSpecificFields={renderPlatformSpecificFields}
      socialChannelList={socialChannelList}
    />
  );
};

export default SocialPublishCard;
